/* eslint-disable react/no-unstable-nested-components */
import { useContext } from 'react';
import { Box, InputLabel, MenuItem, Select, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { CustomSelectStyles as classes } from './CustomSelectStyles';

import { commonTernary } from '../../commonCode';
import { DownArrowIcon } from '../../../images/svg/CustomizedSVG';
import LeadGenerationContext from '../../../context/LeadGenerationContext';

export const CustomSelectAccountNo = ({
  id,
  dataTestId,
  required,
  inputLabelAriaLabel,
  inputLabelClassName,
  label,
  autoFocus,
  options,
  InputClassName,
  handleChange,
  fullWidth,
  value,
  selectAriaLabel,
  disabled,
  nsSeparator,
  isState,
  dataTestIdForLabel,
  isUtilityBill,
  error,
  showLabel,
  textLabel,
  // noPlaceHolderLabel,
  // corporateTitlePlaceholder,
}) => {
  const { t } = useTranslation();
  const leadGenerationContext = useContext(LeadGenerationContext);
  const { theme } = leadGenerationContext;
  const commonSelectFunction = (data1, data2) => {
    let data;
    if (data1) {
      data = data1;
    } else {
      data = data2;
    }
    return data;
  };

  return (
    <>
      <InputLabel
        data-testid={commonSelectFunction(dataTestIdForLabel, null)}
        htmlFor={commonSelectFunction(id, null)}
        aria-label={commonSelectFunction(inputLabelAriaLabel, null)}
        className={`${classes.label_title} ${commonSelectFunction(inputLabelClassName, '')}`}
        required={commonSelectFunction(required, false)}
      >
        {commonSelectFunction(label, '')}
      </InputLabel>
      <Select
        variant="outlined"
        role="listbox"
        id={commonSelectFunction(id, null)}
        className={commonTernary(
          error,
          `${classes.select_inputs} ${commonSelectFunction(InputClassName, '')} ${
            classes.select_inputs_err
          }`,
          commonTernary(
            disabled,
            `${classes.select_inputs} ${commonSelectFunction(InputClassName, '')} ${
              classes.select_inputs_disabled
            }`,
            `${classes.select_inputs} ${commonSelectFunction(InputClassName, '')}`
          )
        )}
        onChange={handleChange}
        disabled={!!disabled}
        name={commonSelectFunction(id, null)}
        inputProps={{ 'data-testid': commonSelectFunction(id, null) }}
        autoFocus={commonSelectFunction(autoFocus, false)}
        aria-label={commonSelectFunction(selectAriaLabel, null)}
        data-testid={commonSelectFunction(dataTestId, '')}
        fullWidth={commonSelectFunction(fullWidth, false)}
        IconComponent={() => (
          <Box padding="0 10px 0 0">
            <DownArrowIcon
              style={{ width: 24, height: 24 }}
              color={theme?.palette?.orientalPrimary?.main}
            />
          </Box>
        )}
        value={commonSelectFunction(value, '')}
        classes={{
          icon: classes.select_icon,
          select: commonTernary(
            value === null || value === '' || value === 'Select',
            classes.select_inputs_placeholder,
            commonTernary(disabled, classes.disable_select_style, classes.select_style)
          ),
        }}
        displayEmpty
      >
        <MenuItem role="option" value="">
          {showLabel
            ? t(textLabel, { defaultValue: textLabel })
            : t('Select', { defaultValue: 'Select' })}
        </MenuItem>
        {commonTernary(
          nsSeparator,
          options &&
            options.map((option, index) => (
              <MenuItem
                key={option.Id}
                disabled={
                  option.isDepositeGreaterThanBalance ||
                  option.isValid ||
                  option.isDepositeError ||
                  option.isDepositeGreaterThanBalanceSingle
                }
                role="option"
                value={option.Id}
                index={index}
              >
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <Typography
                    style={
                      option.isDepositeGreaterThanBalance ||
                      option.isValid ||
                      option.isDepositeError ||
                      option.isDepositeGreaterThanBalanceSingle
                        ? {
                            color: '#808285',
                            marginBottom: '4px',
                            font: 'normal 400 12px/20px Arial',
                          }
                        : {
                            color: '#F5821F',
                            marginBottom: '4px',
                            font: 'normal 400 12px/20px Arial',
                          }
                    }
                  >
                    {t('ORIENTAL ACCOUNT', {
                      defaultValue: 'ORIENTAL ACCOUNT',
                      nsSeparator,
                    })}
                  </Typography>

                  <Typography
                    style={
                      option.isDepositeGreaterThanBalance ||
                      option.isValid ||
                      option.isDepositeError ||
                      option.isDepositeGreaterThanBalanceSingle
                        ? {
                            color: '#808285',
                            font: 'normal 400 16px/20px Arial',
                          }
                        : {
                            font: 'normal 400 16px/20px Arial',
                            color: '#000000',
                          }
                    }
                  >
                    {option.Balance !== ''
                      ? `${option.AccountNumber} - $ ${option.Balance}`
                      : `${option.AccountNumber}`}
                  </Typography>
                </div>
              </MenuItem>
            )),
          options &&
            options.map((option, index) => (
              <MenuItem
                key={option.Id}
                disabled={
                  option.isDepositeGreaterThanBalance ||
                  option.isValid ||
                  option.isDepositeGreaterThanBalanceSingle ||
                  option.isDepositeError
                }
                role="option"
                value={option.Id}
                index={index}
              >
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <Typography
                    style={
                      option.isDepositeGreaterThanBalance ||
                      option.isValid ||
                      option.isDepositeError ||
                      option.isDepositeGreaterThanBalanceSingle
                        ? {
                            color: '#808285',
                            marginBottom: '4px',
                            font: 'normal 400 12px/20px Arial',
                          }
                        : {
                            color: '#F5821F',
                            marginBottom: '4px',
                            font: 'normal 400 12px/20px Arial',
                          }
                    }
                  >
                    {t('ORIENTAL ACCOUNT', {
                      defaultValue: 'ORIENTAL ACCOUNT',
                      nsSeparator,
                    })}
                  </Typography>
                  <Typography
                    style={
                      option.isDepositeGreaterThanBalance ||
                      option.isValid ||
                      option.isDepositeError ||
                      option.isDepositeGreaterThanBalanceSingle
                        ? {
                            color: '#808285',
                            font: 'normal 400 16px/20px Arial',
                          }
                        : {
                            font: 'normal 400 16px/20px Arial',
                            color: '#000000',
                          }
                    }
                  >
                    {option.Balance !== ''
                      ? `${option.AccountNumber} - $ ${option.Balance}`
                      : `${option.AccountNumber}`}
                  </Typography>
                </div>
              </MenuItem>
            ))
        )}
      </Select>
    </>
  );
};

CustomSelectAccountNo.propTypes = {
  id: PropTypes.string,
  error: PropTypes.string,
  required: PropTypes.bool,
  inputLabelAriaLabel: PropTypes.string,
  inputLabelClassName: PropTypes.string,
  label: PropTypes.string,
  autoFocus: PropTypes.bool,
  showLabel: PropTypes.bool,
  textLabel: PropTypes.string,
  disabled: PropTypes.bool,
  options: PropTypes.array,
  InputClassName: PropTypes.string,
  handleChange: PropTypes.func,
  fullWidth: PropTypes.bool,
  isState: PropTypes.bool,
  isUtilityBill: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  selectAriaLabel: PropTypes.string,
  dataTestId: PropTypes.string,
  nsSeparator: PropTypes.string,
  dataTestIdForLabel: PropTypes.string,
  // noPlaceHolderLabel: PropTypes.bool,
  // corporateTitlePlaceholder: PropTypes.bool,
};
